import type { FC } from "react";

import { useDispatch } from "react-redux";

import type { IconName } from "@similarweb/icons";
import type { ButtonType } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";

import { showSuccessToast, showErrorToast } from "app/actions/toast_actions";
import { translate } from "app/filters/i18nFilter";

interface ICopyToClipboard {
    textToCopy: string;
    buttonText?: string;
    buttonType?: ButtonType;
    iconName?: IconName;
    successToast?: string;
    errorToast?: string;
    isDisabled?: boolean;
    onCopyToClipboardClick?: () => unknown;
}

export const CopyToClipboardButton: FC<ICopyToClipboard> = ({
    textToCopy,
    buttonText = translate("copy_to_clipboard_button.text"),
    buttonType = "outlined",
    iconName = "copy",
    successToast = translate("copy_to_clipboard_button.toast.success"),
    errorToast = translate("copy_to_clipboard_button.toast.failure"),
    isDisabled = false,
    onCopyToClipboardClick,
}) => {
    const dispatch = useDispatch();

    const handleCopyClick = async () => {
        onCopyToClipboardClick?.();
        try {
            await navigator.clipboard.writeText(textToCopy);
            dispatch(showSuccessToast(translate(successToast)));
        } catch (error) {
            dispatch(showErrorToast(translate(errorToast)));
        }
    };

    return (
        <IconButton
            type={buttonType}
            iconName={iconName}
            onClick={handleCopyClick}
            isDisabled={isDisabled}
        >
            {translate(buttonText)}
        </IconButton>
    );
};
